import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ref, push, set } from 'firebase/database';
import { db } from '../firebaseConfig';
import Navbar from '../components/Navbar';
import LocationPicker from '../components/LocationPicker';
import MapPreview from '../components/MapPreview';
import { useLanguage } from '../LanguageContext';


export default function OfferPage() {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [user, setUser] = useState(null);

  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
const [fromCoord, setFromCoord] = useState(null);
const [toCoord, setToCoord] = useState(null);
const [fromAddress, setFromAddress] = useState('');
const [toAddress, setToAddress] = useState('');
  const [showRoute, setShowRoute] = useState(false);
  const [routeCoords, setRouteCoords] = useState([]);
  const [distanceKm, setDistanceKm] = useState(0);
  const [durationMin, setDurationMin] = useState(0);
  const [calculatingReach, setCalculatingReach] = useState(false);

  const [dateOption, setDateOption] = useState('today');
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [showCalendar, setShowCalendar] = useState(false);
  const [time, setTime] = useState('09:00');
  const [reachTime, setReachTime] = useState('');
  const [pickupPoint, setPickupPoint] = useState('');

  const [allowMiddleRoute, setAllowMiddleRoute] = useState(true);

  const [hasReturnJourney, setHasReturnJourney] = useState(false);
  const [returnDate, setReturnDate] = useState(new Date());
  const [showReturnCalendar, setShowReturnCalendar] = useState(false);
  const [returnTime, setReturnTime] = useState('18:00');
  const [returnReachTime, setReturnReachTime] = useState('');

  const [seats, setSeats] = useState(2);
  const [price, setPrice] = useState('');
  const [vehicle, setVehicle] = useState('');
  const [vehiclePhoto, setVehiclePhoto] = useState(null);
  const [posting, setPosting] = useState(false);
  const [availableRoutes, setAvailableRoutes] = useState([]);
const [selectedRouteIndex, setSelectedRouteIndex] = useState(0);

  useEffect(() => {
    const savedUser = localStorage.getItem('guningo_user');
    if (!savedUser) {
      navigate('/');
      return;
    }
    setUser(JSON.parse(savedUser));
  }, [navigate]);

  const isGuest = user && (!user.name || user.name === 'Guest User');

  const formatDate = (date) => {
    const day = date.getDate().toString().padStart(2, '0');
    const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const weekdays = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    return weekdays[date.getDay()] + ' ' + day + ' ' + months[date.getMonth()];
  };

  const selectToday = () => { setSelectedDate(new Date()); setDateOption('today'); };
  const selectTomorrow = () => {
    const tmr = new Date();
    tmr.setDate(tmr.getDate() + 1);
    setSelectedDate(tmr);
    setDateOption('tomorrow');
  };

  const formatTimeDisplay = (timeStr) => {
    const [h, m] = timeStr.split(':');
    const hour = parseInt(h);
    const period = hour >= 12 ? 'PM' : 'AM';
    const displayHour = hour % 12 === 0 ? 12 : hour % 12;
    return displayHour + ':' + m + ' ' + period;
  };

  const addMinutesToTimeStr = (timeStr, mins) => {
    const [h, m] = timeStr.split(':').map(Number);
    const base = new Date();
    base.setHours(h, m, 0, 0);
    const result = new Date(base.getTime() + mins * 60000);
    const rh = result.getHours();
    const rm = result.getMinutes().toString().padStart(2, '0');
    const period = rh >= 12 ? 'PM' : 'AM';
    const displayHour = rh % 12 === 0 ? 12 : rh % 12;
    return displayHour + ':' + rm + ' ' + period;
  };

 
  useEffect(() => {
    if (durationMin > 0) {
      setReachTime(addMinutesToTimeStr(time, durationMin));
    }
  }, [durationMin, time]);

  useEffect(() => {
    if (hasReturnJourney && durationMin > 0) {
      setReturnReachTime(addMinutesToTimeStr(returnTime, durationMin));
    }
  }, [returnTime, hasReturnJourney, durationMin]);

const handleFromSelect = (place) => {
  setFrom(place.cityName);
  setFromAddress(place.fullAddress || place.displayName || place.cityName);
  setFromCoord({ latitude: place.latitude, longitude: place.longitude });
  setShowRoute(false);
  setAvailableRoutes([]);
};

const handleToSelect = (place) => {
  setTo(place.cityName);
  setToAddress(place.fullAddress || place.displayName || place.cityName);
  setToCoord({ latitude: place.latitude, longitude: place.longitude });
  setShowRoute(false);
  setAvailableRoutes([]);
};

const handleRoutesFound = (routes) => {
  setAvailableRoutes(routes);
  const chosen = routes[selectedRouteIndex] || routes[0];
  if (chosen) {
    setDistanceKm(chosen.distanceKm);
    setDurationMin(chosen.durationMin);
    setRouteCoords(chosen.coords);
  }
};

const selectRoute = (index) => {
  setSelectedRouteIndex(index);
  const chosen = availableRoutes[index];
  if (chosen) {
    setDistanceKm(chosen.distanceKm);
    setDurationMin(chosen.durationMin);
    setRouteCoords(chosen.coords);
  }
};
  const handleVehiclePhotoChange = (file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => setVehiclePhoto(reader.result);
    reader.readAsDataURL(file);
  };

  const postRide = async () => {
    if (isGuest) {
      alert('Please login to post a ride.');
      navigate('/');
      return;
    }
    if (!from.trim() || !to.trim()) {
      alert('Please select both departure and destination.');
      return;
    }
    if (!price.trim() || isNaN(parseInt(price))) {
      alert('Please enter a valid price per seat.');
      return;
    }
    if (!vehicle.trim()) {
      alert('Please enter your vehicle details.');
      return;
    }

    setPosting(true);
try {
  const ridesRef = ref(db, 'rides/');
  const outboundRideRef = push(ridesRef);

  const sharedFields = {
    seats: seats,
    price: parseInt(price),
    vehicle: vehicle.trim(),
    vehiclePhoto: vehiclePhoto || null,
    allowMiddleRoute: allowMiddleRoute,
    driver: user.name,
    driverPhone: user.phone,
    rating: user.rating || '5.0',
    initials: user.initials,
    driverVerified: user.docsVerified || false,
    status: 'active',
    postedAt: new Date().toISOString(),
  };

  let returnRideKey = null;
  if (hasReturnJourney) {
    const returnRideRef = push(ridesRef);
    returnRideKey = returnRideRef.key;

    await set(returnRideRef, {
  ...sharedFields,
  from: to.trim(),
  to: from.trim(),
  fromAddress: toAddress || to.trim(),
  toAddress: fromAddress || from.trim(),
  fromLat: toCoord?.latitude || null,
      fromLng: toCoord?.longitude || null,
      toLat: fromCoord?.latitude || null,
      toLng: fromCoord?.longitude || null,
      routeCoords: routeCoords.length > 0 ? [...routeCoords].reverse() : null,
      date: formatDate(returnDate),
      dateISO: returnDate.toISOString().split('T')[0],
      time: formatTimeDisplay(returnTime),
      reachTime: returnReachTime || '—',
      pickupPoint: '',
      distanceKm: Math.round(distanceKm),
      linkedRideId: outboundRideRef.key,
      isReturnLeg: true,
    });
  }

  await set(outboundRideRef, {
  ...sharedFields,
  from: from.trim(),
  to: to.trim(),
  fromAddress: fromAddress || from.trim(),
  toAddress: toAddress || to.trim(),
  fromLat: fromCoord?.latitude || null,
    fromLng: fromCoord?.longitude || null,
    toLat: toCoord?.latitude || null,
    toLng: toCoord?.longitude || null,
    routeCoords: routeCoords.length > 0 ? routeCoords : null,
    date: formatDate(selectedDate),
    dateISO: selectedDate.toISOString().split('T')[0],
    time: formatTimeDisplay(time),
    reachTime: reachTime || '—',
    pickupPoint: pickupPoint.trim(),
    distanceKm: Math.round(distanceKm),
    hasReturnJourney: hasReturnJourney,
    returnDate: hasReturnJourney ? formatDate(returnDate) : null,
    returnDepartTime: hasReturnJourney ? formatTimeDisplay(returnTime) : null,
    returnReachTime: hasReturnJourney ? returnReachTime : null,
    linkedRideId: returnRideKey,
    isReturnLeg: false,
  });

  setPosting(false);
  alert(hasReturnJourney ? 'Your outbound and return rides are both now live on Guningo.' : 'Ride posted successfully!');
  navigate('/home');
} catch (error) {
  setPosting(false);
  alert('Error: ' + error.message);
}
  };

  if (!user) return null;

  const earnings = seats && price ? seats * (parseInt(price) || 0) : 0;

  return (
    <div style={styles.page}>
      <Navbar userName={user.name} userPhone={user.phone} />
      <div style={styles.container}>

        <h2 style={styles.pageTitle}>{t('postARide')}</h2>

        <div style={styles.mainGrid}>
          <div style={styles.leftCol}>

            <div style={styles.card}>
              <h3 style={styles.cardTitle}>{t('routeDetails')}</h3>

              <label style={styles.fieldLabel}>{t('departureCity')}</label>
              <LocationPicker placeholder="e.g. Mathura" value={from} onSelect={handleFromSelect} />

              <label style={styles.fieldLabel}>{t('destinationCity')}</label>
              <LocationPicker placeholder="e.g. Delhi" value={to} onSelect={handleToSelect} />

              <label style={styles.fieldLabel}>{t('travelDate')}</label>
              <div style={styles.dateRow}>
                <button style={dateOption === 'today' ? styles.dateChipActive : styles.dateChip} onClick={selectToday}>{t('today')}</button>
                <button style={dateOption === 'tomorrow' ? styles.dateChipActive : styles.dateChip} onClick={selectTomorrow}>{t('tomorrow')}</button>
                <button style={dateOption === 'custom' ? styles.dateChipActive : styles.dateChip} onClick={() => setShowCalendar(true)}>
                  📆 {dateOption === 'custom' ? formatDate(selectedDate) : 'Choose date'}
                </button>
              </div>
              {showCalendar && (
                <input
                  type="date"
                  style={styles.dateInput}
                  min={new Date().toISOString().split('T')[0]}
                  onChange={(e) => {
                    if (e.target.value) {
                      setSelectedDate(new Date(e.target.value + 'T00:00:00'));
                      setDateOption('custom');
                    }
                    setShowCalendar(false);
                  }}
                  autoFocus
                />
              )}

              <label style={styles.fieldLabel}>{t('departureTime')}</label>
              <input type="time" style={styles.input} value={time} onChange={e => setTime(e.target.value)} />

              <label style={styles.fieldLabel}>{t('reachTime') || 'Reach time (auto-calculated)'}</label>
              <div style={styles.staticField}>
                🕐 {calculatingReach ? 'Calculating...' : (reachTime || '—')}
              </div>

              <label style={styles.fieldLabel}>Pickup point (optional)</label>
              <input style={styles.input} placeholder="e.g. Bus stand Gate 4" value={pickupPoint} onChange={e => setPickupPoint(e.target.value)} />
            </div>

            <div style={styles.toggleCard} onClick={() => setAllowMiddleRoute(!allowMiddleRoute)}>
              <div style={allowMiddleRoute ? styles.checkboxActive : styles.checkbox}>{allowMiddleRoute && '✓'}</div>
              <div>
                <div style={styles.toggleTitle}>Allow pickup/drop-off along the route</div>
                <div style={styles.toggleSub}>Passengers travelling part of your route can book too</div>
              </div>
            </div>

            <div style={styles.toggleCard} onClick={() => setHasReturnJourney(!hasReturnJourney)}>
              <div style={hasReturnJourney ? styles.checkboxActive : styles.checkbox}>{hasReturnJourney && '✓'}</div>
              <div>
                <div style={styles.toggleTitle}>Add return journey</div>
                <div style={styles.toggleSub}>{to || 'Destination'} back to {from || 'departure'}</div>
              </div>
            </div>

            {hasReturnJourney && (
              <div style={styles.card}>
                <label style={styles.fieldLabel}>Return date</label>
                <button style={styles.dateChip} onClick={() => setShowReturnCalendar(true)}>📅 {formatDate(returnDate)}</button>
                {showReturnCalendar && (
                  <input
                    type="date"
                    style={styles.dateInput}
                    min={selectedDate.toISOString().split('T')[0]}
                    onChange={(e) => {
                      if (e.target.value) setReturnDate(new Date(e.target.value + 'T00:00:00'));
                      setShowReturnCalendar(false);
                    }}
                    autoFocus
                  />
                )}
                <label style={styles.fieldLabel}>Return departure time</label>
                <input type="time" style={styles.input} value={returnTime} onChange={e => setReturnTime(e.target.value)} />
                <label style={styles.fieldLabel}>Return reach time (auto-calculated)</label>
                <div style={styles.staticField}>🕐 {returnReachTime || '—'}</div>
              </div>
            )}

            <div style={styles.card}>
              <h3 style={styles.cardTitle}>Ride preferences</h3>

              <label style={styles.fieldLabel}>{t('availableSeats')}</label>
              <div style={styles.seatsRow}>
                {[1, 2, 3, 4, 5].map(n => (
                  <button key={n} style={seats === n ? styles.seatChipActive : styles.seatChip} onClick={() => setSeats(n)}>{n}</button>
                ))}
              </div>

              <label style={styles.fieldLabel}>{t('pricePerSeat')} (₹)</label>
              <input style={styles.input} placeholder="e.g. 350" value={price} onChange={e => setPrice(e.target.value)} type="number" />

              <label style={styles.fieldLabel}>{t('vehicle')}</label>
              <input style={styles.input} placeholder="e.g. Swift Dzire White" value={vehicle} onChange={e => setVehicle(e.target.value)} />

              <label style={styles.fieldLabel}>Vehicle photo (optional)</label>
              {vehiclePhoto ? (
                <div>
                  <img src={vehiclePhoto} alt="Vehicle" style={styles.vehiclePhotoPreview} />
                  <button style={styles.changePhotoBtn} onClick={() => document.getElementById('vehiclePhotoInput').click()}>Change photo</button>
                </div>
              ) : (
                <button style={styles.photoUploadBtn} onClick={() => document.getElementById('vehiclePhotoInput').click()}>+ Add photo</button>
              )}
              <input
                id="vehiclePhotoInput"
                type="file"
                accept="image/*"
                style={{ display: 'none' }}
                onChange={e => handleVehiclePhotoChange(e.target.files[0])}
              />
            </div>

            {seats && price ? (
              <div style={styles.earningsCard}>
                <span>You earn ({seats} seats)</span>
                <span style={styles.earningsVal}>₹{earnings}</span>
              </div>
            ) : null}

            <button style={styles.postBtn} onClick={postRide} disabled={posting}>
              {posting ? 'Posting...' : t('postRide')}
            </button>
          </div>

<div style={styles.rightCol} className="offer-right-col">  {(fromCoord || toCoord) ? (
    <>
      <div style={styles.mapWrap}>
        <MapPreview
          fromCoord={fromCoord}
          toCoord={toCoord}
          showRoute={showRoute}
          selectedRouteIndex={selectedRouteIndex}
          onRoutesFound={handleRoutesFound}
        />
      </div>
      {fromCoord && toCoord && (
        <button style={styles.routeBtn} onClick={() => setShowRoute(!showRoute)}>
          {showRoute ? '✕ Hide Route' : '🗺️ Choose from multiple routes'}
        </button>
      )}

      {showRoute && availableRoutes.length > 0 && (
        <div style={styles.routeOptionsBox}>
          <p style={styles.routeOptionsTitle}>Available routes</p>
          {availableRoutes.map((route, idx) => (
            <div
              key={idx}
              style={selectedRouteIndex === idx ? styles.routeOptionActive : styles.routeOption}
              onClick={() => selectRoute(idx)}
            >
              <div style={selectedRouteIndex === idx ? styles.radioDotActive : styles.radioDot}></div>
              <div style={{ flex: 1 }}>
                <div style={styles.routeOptionTitle}>{idx === 0 ? 'Fastest route' : 'Alternative route ' + idx}</div>
                <div style={styles.routeOptionMeta}>
                  {Math.round(route.distanceKm)} km · {Math.round(route.durationMin)} mins
                </div>
              </div>
              {selectedRouteIndex === idx && <span style={{ color: '#00c896', fontWeight: 700 }}>✓</span>}
            </div>
          ))}
        </div>
      )}

      {distanceKm > 0 && (
        <p style={styles.distanceNote}>Selected: {Math.round(distanceKm)} km · {Math.round(durationMin)} mins</p>
      )}
    </>
  ) : (
    <div style={styles.mapPlaceholder}>
      <p style={{ color: '#9499b5', fontSize: 13 }}>Select departure and destination to see route options</p>
    </div>
  )}
</div>
        </div>

      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: '100vh', background: '#ffffff', fontFamily: 'Arial, sans-serif' },
  container: { maxWidth: 1100, margin: '0 auto', padding: '30px 20px 40px' },
  pageTitle: { color: '#1a1a2e', marginBottom: 20 },
  mainGrid: { display: 'flex', gap: 30, flexWrap: 'wrap' },
  leftCol: { flex: '1.2 1 400px', maxWidth: 520 },
  rightCol: { flex: '1 1 320px', position: 'sticky', top: 90, alignSelf: 'flex-start' },
  card: { border: '1px solid #eef1f8', borderRadius: 14, padding: 20, marginBottom: 16 },
  cardTitle: { margin: '0 0 6px', color: '#1a1a2e' },
  fieldLabel: { display: 'block', fontSize: 12, fontWeight: 600, color: '#5a5f7d', marginBottom: 5, marginTop: 12 },
  input: { width: '100%', height: 44, borderRadius: 8, border: '1.5px solid #d9edfa', padding: '0 12px', fontSize: 14, boxSizing: 'border-box' },
  staticField: { height: 44, borderRadius: 8, background: '#f7f9fc', border: '1px solid #eef1f8', display: 'flex', alignItems: 'center', padding: '0 12px', fontSize: 14, color: '#1a1a2e' },
  dateRow: { display: 'flex', gap: 8, flexWrap: 'wrap' },
  dateChip: { flex: 1, minWidth: 90, height: 38, borderRadius: 8, border: '1.5px solid #d9edfa', background: '#f7f9fc', color: '#5a5f7d', fontWeight: 600, cursor: 'pointer', fontSize: 12 },
  dateChipActive: { flex: 1, minWidth: 90, height: 38, borderRadius: 8, border: '1.5px solid #3a8fd0', background: '#3a8fd0', color: '#ffffff', fontWeight: 600, cursor: 'pointer', fontSize: 12 },
  dateInput: { width: '100%', height: 40, borderRadius: 8, border: '1.5px solid #3a8fd0', padding: '0 12px', fontSize: 14, marginTop: 10, boxSizing: 'border-box' },
  toggleCard: { display: 'flex', alignItems: 'center', gap: 12, border: '1px solid #eef1f8', borderRadius: 14, padding: 16, marginBottom: 14, cursor: 'pointer' },
  checkbox: { width: 20, height: 20, borderRadius: 5, border: '1.5px solid #d9edfa', flexShrink: 0 },
  checkboxActive: { width: 20, height: 20, borderRadius: 5, background: '#e94560', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700, flexShrink: 0 },
  toggleTitle: { fontSize: 13, fontWeight: 700, color: '#1a1a2e' },
  toggleSub: { fontSize: 11, color: '#9499b5' },
  routeOptionsBox: { marginTop: 12, border: '1px solid #eef1f8', borderRadius: 12, padding: 10 },
routeOptionsTitle: { fontSize: 11, fontWeight: 700, color: '#9499b5', margin: '0 0 8px', paddingLeft: 4 },
routeOption: { display: 'flex', alignItems: 'center', gap: 10, padding: 10, borderRadius: 8, cursor: 'pointer' },
routeOptionActive: { display: 'flex', alignItems: 'center', gap: 10, padding: 10, borderRadius: 8, cursor: 'pointer', background: '#eaf5fc' },
radioDot: { width: 16, height: 16, borderRadius: 8, border: '2px solid #d9edfa', flexShrink: 0 },
radioDotActive: { width: 16, height: 16, borderRadius: 8, border: '2px solid #3a8fd0', background: '#3a8fd0', flexShrink: 0 },
routeOptionTitle: { fontSize: 13, fontWeight: 600, color: '#1a1a2e' },
routeOptionMeta: { fontSize: 11, color: '#9499b5' },
  seatsRow: { display: 'flex', gap: 8 },
  seatChip: { width: 40, height: 40, borderRadius: 8, border: '1.5px solid #d9edfa', background: '#f7f9fc', color: '#1a1a2e', fontWeight: 700, cursor: 'pointer', fontSize: 14 },
  seatChipActive: { width: 40, height: 40, borderRadius: 8, border: '1.5px solid #3a8fd0', background: '#3a8fd0', color: '#ffffff', fontWeight: 700, cursor: 'pointer', fontSize: 14 },
  photoUploadBtn: { height: 60, width: '100%', borderRadius: 10, border: '1px dashed #d9edfa', background: '#fff', color: '#7fa3c4', cursor: 'pointer', fontSize: 13 },
  vehiclePhotoPreview: { width: '100%', height: 140, borderRadius: 10, objectFit: 'cover', marginBottom: 8 },
  changePhotoBtn: { width: '100%', height: 34, borderRadius: 8, border: '1px solid #d9edfa', background: '#f7f9fc', cursor: 'pointer', fontSize: 12, fontWeight: 600, color: '#3a8fd0' },
  earningsCard: { background: '#eaf4ea', border: '1px solid #86efac', borderRadius: 12, padding: 12, marginBottom: 12, display: 'flex', justifyContent: 'space-between', color: '#166534', fontWeight: 600 },
  earningsVal: { fontSize: 16, fontWeight: 700 },
  postBtn: { width: '100%', height: 50, background: '#3a8fd0', color: '#fff', border: 'none', borderRadius: 12, fontSize: 15, fontWeight: 700, cursor: 'pointer' },
  mapWrap: { width: '100%', height: 320, borderRadius: 16, overflow: 'hidden', boxShadow: '0 8px 24px rgba(0,0,0,0.1)' },
  routeBtn: { width: '100%', height: 44, marginTop: 12, background: '#3a8fd0', color: '#fff', border: 'none', borderRadius: 10, fontWeight: 700, cursor: 'pointer', fontSize: 14 },
  distanceNote: { fontSize: 12, color: '#5a5f7d', textAlign: 'center', marginTop: 8 },
  mapPlaceholder: { width: '100%', height: 320, borderRadius: 16, background: '#f7f9fc', border: '1px dashed #d9edfa', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: 20 },
};